<template>
  <div :data-id="`${item.product_id}`" class="listing-item " :class="{ zoom: props.hover_zoom }"
    @mouseenter="onMouseOver(item.id)" @mouseleave="onMouseLeave" style="cursor: pointer"
    :style="getHoverStyle(item.id)" :data-gallery="gallery">

    <!--
      A visible product card makes Nuxt prefetch the whole /product/[slug] route by
      default. That route contains the customiser, gallery zoom and add-to-cart
      code, so a row of cards was downloading the product-page bundle on Home.
      Keep navigation client-side, but load that route only after a real click.
    -->
    <NuxtLink :to="getLangUrlItem(props.item?.slug, baseUrl, locale)" no-prefetch>
      <div class="listing-item__media"
        @touchstart.stop
        @touchmove.stop
        @touchend.stop>
        <div v-if="type !== 4" class="listing-item__media-label-wrapper">
          <div class="listing-item__media-label-wrapper listing-item__media-sale">
            <div class="listing-item__media-sale-info" v-html="htmlSpecialcharsDecode(htmlTag)"></div>
            <div class="sale_discount"
              v-if="(!props.min_max && props.item?.sale_discount && parseInt(props.item?.sale_discount, 10) >= 5) || (props.min_max && parseInt(item.max_price) == 0 && parseInt(props.item?.sale_discount, 10) >= 5)">
              <img class="isting-item__media-sale--discount" src="/vc-02.svg" alt="image" />
              <span>-{{ props.item?.sale_discount }}%</span>
            </div>
          </div>
        </div>

        <!-- Swiper Slider (if multiple media items exist) -->
        <ClientOnly>
          <swiper :key="`${props.item?.product_id || props.item?.id || ''}-${gallery}`"
            v-if="props.active_slider && mediaList.length > 1 && !isCustomisable"
            :slides-per-view="1"
            :loop="true"
            :nested="true"
            :touch-move-stop-propagation="true"
            :touch-angle="65"
            :long-swipes-ratio="0.1"
            :prevent-clicks="true"
            :prevent-clicks-propagation="true"
            :pagination="{ clickable: true }"
            :modules="modules"
            :observer="true"
            :observe-parents="true"
            class="product-item-swiper"
            @swiper="onSwiper"
            @click.capture.stop="handleSwiperClick">
            <swiper-slide v-for="(media, idx) in mediaList" :key="`${media.src}-${idx}`">
              <template v-if="media.type === 'video'">
                <video class="listing-item__media-video active_auto_play" autoplay loop muted playsinline>
                  <source :src="media.src" type="video/mp4" />
                </video>
              </template>
              <template v-else>
                <img :src="media.src" :alt="media.alt || props.item?.title || 'image'" class="listing-item__media-image" loading="lazy" />
              </template>
            </swiper-slide>
          </swiper>

          <!-- Fallback to original image/video hover if 1 or 0 media items -->
          <template v-else>
            <img v-if="!props.item" src="/default.gif" class="listing-item__media-image img1" />

            <img v-if="showImg1" :src="img1Src" :alt="img1Alt" class="listing-item__media-image img1" loading="lazy" />
            <img v-if="showImg2" :src="img2Src" :alt="img2Alt" class="listing-item__media-image img2" loading="lazy" />

            <video v-if="showVideoHover || showVideoAutoplay" :class="[
              'listing-item__media-video',
              {
                video_hover: showVideoHover,
                active_auto_play: showVideoAutoplay
              }
            ]" autoplay loop muted playsinline v-show="!onHouver">
              <source :src="videoSrc" type="video/mp4" />
            </video>
          </template>

          <template #fallback>
            <img v-if="!props.item" src="/default.gif" class="listing-item__media-image img1" />
            <img v-if="showImg1" :src="img1Src" :alt="img1Alt" class="listing-item__media-image img1" loading="lazy" />
            <img v-if="showImg2" :src="img2Src" :alt="img2Alt" class="listing-item__media-image img2" loading="lazy" />
          </template>
        </ClientOnly>
        <div :data-name="htmlSpecialcharsDecode(props.item?.title)" :class="[
          props.whistlist !== false ? 'listing-item__wishlist' : '',
          { active: isActive_wishlist }
        ]" @click="wishListItem($event, item.product_id)"></div>
      </div>


      <div class="listing-item__info">
        <p class="listing-item__info-name" v-html="htmlSpecialcharsDecode(props.item?.title)"></p>
        <slot v-if="item?.hide_price !== 1">
          <div class="w_price " v-if="!props.min_max || (props.min_max && parseInt(item.max_price) == 0)">
            <span class="regular_price"
              v-if="item.sale_price !== '' && parseInt(item.sale_price) !== 0 && parseInt(item.regular_price) > parseInt(item.sale_price)">
              {{ displayCustomPrice(item?.sale_price) }}
            </span>
            <ins>
              <span class="woocommerce-Price-amount amount"
                :class="item.sale_price !== '' && parseInt(item.sale_price) !== 0 && parseInt(item.regular_price) > parseInt(item.sale_price) ? '' : ' regular_pr'"
                v-if="item?.sale_discount && parseInt(item.regular_price) > 0">
                {{ displayCustomPrice(item?.regular_price) }}
              </span>


              <span class="woocommerce-Price-amount amount" :class="{ 'regular_pr': !shortTermValue }"
                v-else-if="parseInt(item.regular_price) > 0">
                {{ displayCustomPrice(item?.regular_price) }}
              </span>
            </ins>
          </div>
          <div class="w_price price_min_max"
            v-if="props.item?.type !== 'simple' && props.min_max && parseInt(item.max_price) > 0">
            <span class="regular_price" v-if="props.item?.price !== '' && parseInt(item.max_price) > 0">
              {{ displayCustomPrice(item?.price) }}
            </span>
            <span class="connect_pr"
              v-if="props.item?.max_price !== '' && parseInt(item.max_price) > 0 && parseInt(item.max_price) != parseInt(item.price)">
              - </span>
            <ins>
              <span class="woocommerce-Price-amount amount"
                v-if="props.item?.max_price !== '' && parseInt(item.max_price) > 0 && props.item?.max_price != props.item?.price">
                {{ displayCustomPrice(item?.max_price) }}</span>
            </ins>
          </div>
        </slot>
        <div class="custom_pt_review" v-if="props.item?.reviews && props.item?.reviews.rating > 0">
          <span class="stamped-starrating stamped-summary-starrating" aria-hidden="true">
            <template v-for="i in ratingStars.fullStars" :key="`star-${i}`">
              <i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>
            </template>
            <i v-if="ratingStars.hasHalfStar" class="stamped-fa stamped-fa-star-half-o" aria-hidden="true"></i>
            <template v-for="i in ratingStars.emptyStars" :key="`empty-star-${i}`">
              <i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>
            </template>
          </span>
          <span class="number_review" v-if="props.item?.reviews && props.item?.reviews.count > 0">({{
            props.item?.reviews?.count ?? 0 }} reviews)</span>
        </div>
        <ProductShortTerm @is-teaser="handleTeaser" @short-term="handleShortTerm" :data="item.short_sale"
          v-if="item.short_sale && Object.keys(item.short_sale).length" />
      </div>
    </NuxtLink>
  </div>
</template>


<script setup lang="ts">
import { ref, computed, watch, nextTick } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination as SwiperPagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import type { IProductItem } from "~/types/productItem";
import { displayCustomPrice } from '@/utils/displayPrice'
import { htmlSpecialcharsDecode } from '@/utils/helpers'
import type { IAPIResponseError } from '~/types/apiResponseError';
import ProductShortTerm from "./ProductShortTerm.vue";
import { useCustomGtm } from '~/composables/useEventTagManager';
import { useInsiderSdk } from '~/composables/insiderSdk';
import { setCookie, getCookie } from "@/utils/cookie";
import { useI18n } from 'vue-i18n';
import { getLangUrl, getLangUrlItem } from '~/utils/getLangUrl';

const runtimeConfig = useRuntimeConfig();
const userStore = useUserStore();
const onHouver = ref<boolean>(true);
const type = ref<number>(1);
const hoveredItemId = ref<number | null>(null);
const background_color = ref('transparent');
const list_item_wishlist = ref<number[]>([]);
const { $ajax } = useNuxtApp();
const { locale } = useI18n();
const baseUrl = runtimeConfig.public.BASE_URL;

const { trackAddWishList, trackRemoveWishList } = useCustomGtm();
const {
  trackInsiderSdkEvent
} = useInsiderSdk();
const showPrice = ref(true);
const props = withDefaults(defineProps<{
  item: IProductItem;
  min_max?: boolean;
  whistlist?: boolean;
  hover_zoom?: boolean;
  background_item?: string;
  active_slider?: boolean;
}>(), {
  whistlist: true,
  hover_zoom: false,
  min_max: false,
  background_item: 'transparent',
  active_slider: false
});

const gallery = ref('');
const shortTermValue = ref(props.item?.short_term);

watch(() => props.item, (newItem) => {
  if (newItem) {
    if (Array.isArray(newItem.gallery)) {
      gallery.value = newItem.gallery.slice(0, 10).join(',');
    } else if (typeof newItem.gallery === 'string' && newItem.gallery) {
      gallery.value = newItem.gallery.split(',').slice(0, 10).join(',');
    } else {
      gallery.value = '';
    }
    shortTermValue.value = newItem.short_term;
    nextTick(() => {
      if (swiperInstanceRef.value && !swiperInstanceRef.value.destroyed) {
        swiperInstanceRef.value.update();
      }
      setTimeout(() => {
        if (swiperInstanceRef.value && !swiperInstanceRef.value.destroyed) {
          swiperInstanceRef.value.update();
        }
      }, 100);
    });
  }
}, { immediate: true, deep: true });

const isCustomisable = computed(() => {
  const customiseID = runtimeConfig.public.CUSTOMISE_ID;
  const term_customiser = props.item?.product_taxonomies?.['product-advanced'] || [];
  return term_customiser.includes(customiseID || '1291');
});

const htmlTag = computed(() => {
  let html = '';
  const customiseID = runtimeConfig.public.CUSTOMISE_ID;
  const term_customiser = props.item?.product_taxonomies?.['product-advanced'] || [];
  const customisable = term_customiser.includes(customiseID);

  const productTag = props.item?.product_tag || '';
  if (productTag != '') {
    html += productTag;
  } else {
    const tags = props.item?.tag || [];

    if (Array.isArray(tags) && tags.length) {
      if (customisable) {
        html += '<span class="aaaaa tag_detail customise_tag_detail">Customisable</span>';
      }
      html += tags
        .map(tag => `
          <span class="bbbbb tag-item ${customisable ? 'customise_tag_detail' : 'new'}">
            ${tag}
          </span>
        `)
        .join('');
    }
  }

  return html;
});

interface IResponse {
  success: boolean;
  data: any[];
};

const isTeaser = ref(false);
const handleTeaser = () => {
  isTeaser.value = true;
};

const isActive_wishlist = computed(() => list_item_wishlist.value.includes(Number(props.item.product_id)));

const ratingStars = computed(() => {
  const rating = props.item?.reviews?.rating ?? 0;
  const floor = Math.floor(rating);
  const decimal = rating - floor;

  let roundedRating;
  if (decimal <= 0.1) {
    roundedRating = floor;
  } else if (decimal <= 0.6) {
    roundedRating = floor + 0.5;
  } else {
    roundedRating = floor + 1;
  }

  const fullStars = Math.floor(roundedRating);
  const hasHalfStar = roundedRating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  return { fullStars, hasHalfStar, emptyStars };
});

const coverHover = computed(() => props.item?.cover_hover);

const hasHover = computed(() => {
  const hover = coverHover.value;
  if (!hover) return false;
  if (Array.isArray(hover)) return hover.length > 0;
  if (typeof hover === 'object') {
    return Object.keys(hover).length > 0;
  }
  return false;
});

const hoverType = computed(() => {
  const hover = coverHover.value;
  return (hasHover.value && typeof hover === 'object' && !Array.isArray(hover))
    ? (hover as any).type
    : '';
});

const hoverAutoplay = computed(() => {
  const hover = coverHover.value;
  return (hasHover.value && typeof hover === 'object' && !Array.isArray(hover))
    ? (hover as any).data?.autoplay
    : '';
});

const hoverSrc = computed(() => {
  const hover = coverHover.value;
  return (hasHover.value && typeof hover === 'object' && !Array.isArray(hover))
    ? (hover as any).data?.src
    : '';
});

const hoverAlt = computed(() => {
  const hover = coverHover.value;
  return (hasHover.value && typeof hover === 'object' && !Array.isArray(hover))
    ? (hover as any).data?.alt ?? ''
    : '';
});

const showImg1 = computed(() => {
  return !(hoverType.value === 'video' && hoverAutoplay.value === 'autoplay');
});

const showImg2 = computed(() => {
  return hasHover.value && hoverType.value === 'image';
});

const showVideoHover = computed(() => {
  return hasHover.value && hoverType.value === 'video' && (hoverAutoplay.value === '' || hoverAutoplay.value === 'hover');
});

const showVideoAutoplay = computed(() => {
  return hasHover.value && hoverType.value === 'video' && hoverAutoplay.value === 'autoplay';
});

const img1Src = computed(() => {
  return props.item?.cover?.src || '/default.webp';
});

const img1Alt = computed(() => {
  return props.item?.cover?.alt || props.item?.title || 'image';
});

const img2Src = computed(() => {
  return hoverSrc.value || props.item?.cover?.src || '/default_hover.webp';
});

const img2Alt = computed(() => {
  return hoverAlt.value || props.item?.title || 'image';
});

const videoSrc = computed(() => {
  return hoverSrc.value || props.item?.cover?.src || '';
});

const videoPosition = computed(() => {
  const position = Number((coverHover.value as any)?.position);
  return Number.isInteger(position) && position > 0 ? position : null;
});

const modules = [SwiperPagination];

const galleryImages = computed(() => {
  if (!props.item?.gallery) return [];
  if (Array.isArray(props.item.gallery)) {
    return props.item.gallery.map(s => (typeof s === 'string' ? s.trim() : '')).filter(Boolean);
  }
  if (typeof props.item.gallery === 'string') {
    return props.item.gallery.split(',').map(s => s.trim()).filter(Boolean);
  }
  return [];
});

const mediaList = computed(() => {
  const list: { type: 'image' | 'video'; src: string; alt?: string }[] = [];
  const seenSources = new Set<string>();
  const hasVideo = (showVideoHover.value || showVideoAutoplay.value) && Boolean(videoSrc.value);

  if (img1Src.value) {
    seenSources.add(img1Src.value);
    list.push({ type: 'image', src: img1Src.value, alt: img1Alt.value || props.item?.title || '' });
  }

  // if ((showVideoHover.value || showVideoAutoplay.value) && videoSrc.value) {
  //   if (!seenSources.has(videoSrc.value)) {
  //     seenSources.add(videoSrc.value);
  //     list.push({ type: 'video', src: videoSrc.value });
  //   }
  // }

  // const remaining = 15 - list.length;
  const remaining = 15 - list.length - (hasVideo ? 1 : 0);
  if (remaining > 0) {
    let added = 0;
    for (const imgUrl of galleryImages.value) {
      if (added >= remaining) break;
      if (imgUrl && !seenSources.has(imgUrl)) {
        seenSources.add(imgUrl);
        list.push({ type: 'image', src: imgUrl, alt: props.item?.title || 'Gallery Image' });
        added++;
      }
    }
  }
  // Insert the video at its one-based API position; default to the second slide.
  if (hasVideo && !seenSources.has(videoSrc.value)) {
    const insertionIndex = Math.min(Math.max((videoPosition.value ?? 2) - 1, 0), list.length);
    list.splice(insertionIndex, 0, { type: 'video', src: videoSrc.value });
  }

  return list;
});

const swiperInstanceRef = ref<any>(null);
const onSwiper = (swiper: any) => {
  swiperInstanceRef.value = swiper;
  nextTick(() => {
    if (swiper && !swiper.destroyed) {
      swiper.update();
      if (swiper.el) {
        const paginationEl = swiper.el.querySelector('.swiper-pagination');
        if (paginationEl) {
          paginationEl.addEventListener('click', (e: Event) => {
            e.stopPropagation();
          }, true);
        }
      }
    }
  });
  setTimeout(() => {
    if (swiperInstanceRef.value && !swiperInstanceRef.value.destroyed) {
      swiperInstanceRef.value.update();
    }
  }, 100);
};

watch(mediaList, () => {
  if (swiperInstanceRef.value && !swiperInstanceRef.value.destroyed) {
    nextTick(() => {
      swiperInstanceRef.value.update();
    });
    setTimeout(() => {
      if (swiperInstanceRef.value && !swiperInstanceRef.value.destroyed) {
        swiperInstanceRef.value.update();
      }
    }, 100);
  }
});

const handleSwiperClick = (e: MouseEvent) => {
  const target = e.target as HTMLElement;
  if (target.classList.contains('swiper-pagination-bullet') || target.closest('.swiper-pagination')) {
    e.stopPropagation();
    e.preventDefault();
  }
};

const handleShortTerm = (price: string) => {
  props.item.sale_price = price;
  props.item.short_term = true;
  shortTermValue.value = true;

  const saleDiscount: number = 100 - (parseInt(props.item.sale_price) / parseInt(props.item.regular_price) * 100);
  props.item.sale_discount = Math.round(saleDiscount).toString();
};

const wishListItem = async (event: any, id_item: Number) => {
  event.stopPropagation();
  event.preventDefault();

  const clickedElement = event.currentTarget as HTMLElement;
  const dataName = clickedElement.getAttribute('data-name');

  id_item = Number(id_item);
  like_item_wishlist(id_item);

  let list_wishlist = JSON.parse(localStorage.getItem('list_wishlist') || '[]');
  const itemIndex = list_wishlist.indexOf(id_item);
  if (itemIndex === -1) {
    if (typeof dataName === 'string' && dataName.trim() !== '') {
      trackAddWishList(dataName);
      trackInsiderSdkEvent('insider_sdk_add_to_wishlist', '', '');
      if (typeof window.lxt !== 'undefined' && dataName) {
        window.lxt('track', 'products_added_to_wishlist', dataName);
      }
    }
    list_wishlist.push(id_item);
  } else {
    if (typeof dataName === 'string' && dataName.trim() !== '') {
      trackRemoveWishList(dataName);
      if (typeof window.lxt !== 'undefined' && dataName) {
        window.lxt('track', 'products_removed_from_wishlist', dataName);
      }
    }
    list_wishlist.splice(itemIndex, 1);
  }
  localStorage.setItem('list_wishlist', JSON.stringify(list_wishlist));

  if (userStore.isLogin) {
    let all_item_wishlist = JSON.parse(localStorage.getItem('all_item_wishlist') || 'null');
    const itemIndex = all_item_wishlist.indexOf(id_item);
    if (itemIndex === -1) {
      all_item_wishlist.push(id_item);
    } else {
      all_item_wishlist.splice(itemIndex, 1);
    }
    localStorage.setItem('all_item_wishlist', JSON.stringify(all_item_wishlist));
    list_item_wishlist.value = all_item_wishlist;
  } else {
    list_item_wishlist.value = list_wishlist;
  }

  isActive_wishlist.value = list_wishlist.includes(Number(props.item.product_id));
};

const like_item_wishlist = async (id_item: Number) => {
  try {
    const response = await $ajax.get<IResponse>(`wp-json/skj/v1/wishlist/like?id_item=${id_item}`, { headers: { "Authorization": `Bearer ${userStore.csrf}`, 'X-API-Server': userStore.csrf_server } });
    if (response.success) {
    }
  } catch (error) {
    if (error && typeof error === 'object' && 'data' in error) {
      const errorData = error.data as IAPIResponseError;
      console.log('wishlistdetailErrorCatch', errorData.code);
    } else {
      console.log('Unexpected error:', error);
    }
  }
};

const getDateTimestamp = (date: string | string[] | null): number => {
  if (!date) return 0;
  if (Array.isArray(date)) {
    return new Date(date[0]).getTime() / 1000;
  }
  return new Date(date).getTime() / 1000;
};

const checkDateInRange = (startDate: string, endDate: string): boolean => {
  if (!startDate || !endDate) {
    return false;
  }
  const sgTime = new Date().toLocaleString('en-US', { timeZone: 'Asia/Singapore' });
  const currentTime = Math.floor(new Date(sgTime).getTime() / 1000);
  const startTime = getDateTimestamp(startDate);
  const endTime = getDateTimestamp(endDate);
  return currentTime >= startTime && currentTime <= endTime;
};

const checkDateInRangeSaleSchedule = (startDate: string, endDate: string): boolean => {
  if (!startDate && !startDate) {
    return true;
  }
  const sgTime = new Date().toLocaleString('en-US', { timeZone: 'Asia/Singapore' });
  const currentTime = Math.floor(new Date(sgTime).getTime() / 1000);
  const startTime = getDateTimestamp(startDate);
  const endTime = getDateTimestamp(endDate);
  if (!startTime && endTime && currentTime <= endTime) return true;
  if (!endTime && startTime && currentTime >= startTime) return true;
  if (startTime && endTime && currentTime >= startTime && currentTime <= endTime) return true;
  return false;
};

onMounted(() => {
  const dataLayer = window.dataLayer || [];
  let wishlistKey = userStore.isLogin ? 'all_item_wishlist' : 'list_wishlist';
  let wishlistData = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
  list_item_wishlist.value = wishlistData;

  let newSaleprice = '';
  let newRegularPrice = '';
  const short_sale = props.item?.short_sale?.short || '';
  if (short_sale != '') {
    const startDate = short_sale?.date_from || '';
    const endDate = short_sale?.date_end || '';
    const price = short_sale?.price || '';
    if (startDate != '' && endDate != '' && price != '') {
      if (checkDateInRange(startDate, endDate)) {
        newSaleprice = price;
        newRegularPrice = short_sale?.regular || '';
      }
    }
  }

  const schedule = props.item?.short_sale?.schedule || '';
  if (schedule != '') {
    const startDate = schedule?.date_from || '';
    const endDate = schedule?.date_end || '';
    const price = schedule?.price || '';
    if (checkDateInRangeSaleSchedule(startDate, endDate) && Number(newSaleprice) > price) {
      newSaleprice = price;
      newRegularPrice = schedule?.regular || '';
    }
  }

  if (Number(newSaleprice) > 0) {
    props.item.sale_price = newSaleprice;
    props.item.regular_price = newRegularPrice;
    const saleDiscount: number = 100 - (parseInt(newSaleprice) / parseInt(newRegularPrice) * 100);
    props.item.sale_discount = Math.round(saleDiscount).toString();
  }
});
background_color.value = props.background_item;

const onMouseOver = (id: string) => {
  if (props.item?.cover || props.item?.cover_hover) {
    onHouver.value = false;
  }
  hoveredItemId.value = parseInt(id);
  return;
};
const onMouseLeave = () => {
  onHouver.value = true;
  hoveredItemId.value = null;
};
const getHoverStyle = (id: string) => {
  return hoveredItemId.value === parseInt(id)
    ? { background: background_color.value }
    : { background: 'transparent' };
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/components/listing/listingItem.scss";

:deep(.tag-item) {
  background: #ffb3c0;
  padding: 5px 8px;
  width: fit-content;
  white-space: nowrap;
}

:deep(.customise_tag_detail) {
  background: #FFEEE6;
  text-transform: capitalize;
  color: #C60C46;
  font-size: 14px;
  padding: 5px 8px;
  white-space: nowrap;
}
</style>

<style lang="scss">
@import "@/assets/scss/components/listing/productMediaCarousel.scss";
</style>
